import ControllerBase from '../../../../global/js/ControllerBase';
import { AtomFilterBtnProps } from "../../atoms/a-filter-btn/a-filter-btn.data";
import { MoleculeCardProps } from "../../molecules/m-card/m-card.data";
import { Component } from "../../../../global/interfaces/component.interface";
import {getCookie, setCookie} from "../../../../global/js/Utils";

export default class ControllerMediacenterList extends ControllerBase {

	private apiUrl = '';
	private assetDownloadList;
	private backDrop;
	private card;
	private cardContainer;
	private clearInput;
	private closeFilterButton;
	private currentPage = 1;
	private counter = 10;
	private disablePerPageChecker = false;
	private documentId;
	private filterApply;
	private filterDrawer;
	private filterRemover;
	private filters = {};
	private loadMore;
	private noResultText;
	private perPage;
	private perPageDesktop;
	private perPageTablet;
	private perPageMobile;
	private searchActions;
	private searchInput;
	private searchTerm = '';
	private selectedFilters;
	private selectedFiltersContainer;
	private submitSearch;
	private toggleFilterButton;
	private totalResults;
	private donwloadList;

	constructor(element: HTMLElement) {
		super(element);
		const elementName = '.o-mediacenter-list' as string;
		this.init(elementName);
		this.submitSearh(elementName);
		this.filterRemover = require('components/atoms/a-filter-btn/a-filter-btn.template.twig') as (data: Component<AtomFilterBtnProps>,) => string;
		this.card = require('components/molecules/m-card/m-card.template.twig') as (data: Component<MoleculeCardProps>,) => string;
	}

	private closeFilter(ignoreCheck = false) {
		this.filterDrawer.setAttribute('data-open', 'false');
		document.body?.classList.remove('filters-opened');
		if (!ignoreCheck) {
			const inputs = this.$element.querySelectorAll('.js-value');
			for (const val of inputs) {
				const input = val as HTMLInputElement;
				const key = input.getAttribute('name') || 'searchTag';
				const active = this.filters[key] || [];
				const changed = input.value ? JSON.parse(input.value) : [];
				let difference = active;
				if (!active.length) {
					difference = changed;
				} else {
					difference = active.filter(x => !changed?.includes(x)).concat(changed?.filter(x => !active.includes(x)));
				}
				if (difference.length) {
					for (const val of difference) {
						const check = document.querySelector(`input[type="checkbox"][data-id="${val}"]`) as HTMLElement;
						check.click();
					}
				} else if (difference && key === 'filterDateRange') {
					if(active.filterDateRangeFrom != changed.filterDateRangeFrom) {
						const check = document.querySelector('.js-range-checkbox') as HTMLElement;
						check.click();
					}
				}
			}
		}
	}

	private setAdded(button:HTMLElement): void {
		button.classList.add('added-to-list');
		const id = button.getAttribute('data-id');
		const addedIcon = this.$element.querySelector('.js-other-icon')?.innerHTML || "";
		// button?.querySelector('.a-button__icon-wrapper')?.innerHTML = addedIcon;
		const buttonGroupsWithSameId = document.querySelectorAll(`.m-button-group[data-id="${id}"]`);
		if (buttonGroupsWithSameId.length > 1) {
			for (const group of buttonGroupsWithSameId) {
				group.classList.add('added-to-list');
				const iconWrapper = group.querySelector('[data-download="add-to-donwloadlist"] .a-button__icon-wrapper') as HTMLElement;
				if (iconWrapper) {
					iconWrapper.innerHTML = addedIcon;
				}
			}
		}
	}

	private addToAssetDownloadList(button:HTMLElement, buttonGroup: HTMLElement){
		const id = JSON.stringify(button.getAttribute('data-id'));
		const assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]");
		let basketSize = parseInt(getCookie('basketSize') || "0");
		const assetSize = buttonGroup.getAttribute('data-size') || "0";
		const maxSize = buttonGroup.getAttribute('data-max-size') || "0";
		if (assetDownloadList.indexOf(id) < 0) {
			basketSize = basketSize + parseInt(assetSize);
			if (basketSize > parseInt(maxSize)) {
				const errorMessage = document.querySelector('[data-show-message]') as HTMLElement;
				if (errorMessage) errorMessage.setAttribute('data-show-message', 'true');
				else alert('Max size reached...');
				return;
			}
			assetDownloadList.push(id);
			setCookie('basketSize', 1, `${basketSize}`);
			setCookie('lastSize', 1, `${assetSize}`);
			setCookie('assetDownloadList', 1, JSON.stringify(assetDownloadList));
		}
		this.setAdded(button);
	}

	private async directDownloadHandler(button:HTMLElement, buttonGroup: HTMLElement){
		let href = buttonGroup.getAttribute('data-api-url') || '';
		const id = button.getAttribute('data-id');
		button.classList.add('downloaded-already');
		let options = {};
		if (href) {
			options = {
				headers: {
					"Content-Type": "application/json"
				},
				method: 'POST',
				body: JSON.stringify({
					"action": "get-token",
					"documentIds": [id],
				})
			};
		} else {
			href = '/downloadAll.json';
		}
		await fetch(href, options)
			.then(response => response.json())
			.then((response) => {
				if (response.data?.['download-token']?.length) {
					const token = response.data['download-token'];
					const downloadUrl = `/download-assets-zipstream/${token}`;
					const a = document.createElement('a');
					a.setAttribute('download', '');
					a.setAttribute('href', downloadUrl);
					a.click();
				}
			})
			.catch(err => console.error(err));
	}

	private shareHandler(button:HTMLElement){
		const windowUrl = window.location.href || undefined;
		const id = button.getAttribute('data-id');
		const title = document.head?.querySelector('title')?.textContent || `Share asset: ${id}!`;
		const text = document.head?.querySelector('meta[name="description"]')?.getAttribute('content') || `Download asset with assetId:${id}`;
		const shareData = {
			title,
			text,
			url: windowUrl,
			file: []
		};
		const windowNavigator = window.navigator;
		if (windowNavigator && windowNavigator.share) {
			windowNavigator
				.share(shareData)
				.then(() => console.info('Successful share'))
				.catch((error) => console.error('Error sharing', error));
		} else {
			if (shareData?.url !== undefined) {
				alert('Successfully copied to clipboard!');
				windowNavigator.clipboard.writeText(shareData?.url);
			}
		}
	}

	private buttonGroupHandler(buttonGroup: HTMLElement) {
		const addToBasket = buttonGroup.querySelector('[data-download="add-to-donwloadlist"]') as HTMLElement;
		if (addToBasket){
			addToBasket.addEventListener('click', () => this.addToAssetDownloadList(addToBasket, buttonGroup));
			const id = addToBasket.getAttribute('data-id');
			this.assetDownloadList.indexOf(`"${id}"`) > -1
				? this.setAdded(addToBasket)
				: addToBasket.classList.remove('added-to-list');
		}
		const directDownload = buttonGroup.querySelector('[data-download="direct-download"]') as HTMLElement;
		if (directDownload) directDownload?.addEventListener('click', () => this.directDownloadHandler(directDownload, buttonGroup));
		const share = buttonGroup.querySelector('[data-download="share"]') as HTMLElement;
		if (share) share.addEventListener('click', () => this.shareHandler(share));
	}

	private async applyFilter(currentPage = 1) {
		this.windowSizeHandler();
		if (!this.disablePerPageChecker && this.perPage) {
			const cardList = this.cardContainer.children;
			let counter = 0;
			for (const c of cardList) {
				const card = c as HTMLElement;
				if (card) {
					if (++counter <= this.perPage) card?.classList.remove('d-none');
					else card?.remove();
				}
			}
		}
		this.closeFilter(true);
		this.disablePerPageChecker = true;
		const inputs = this.$element.querySelectorAll('.js-value');
		const loadMore = this.currentPage < currentPage;
		if (!loadMore) this.cardContainer.classList.add('loading-in-progress');
		this.currentPage = currentPage;
		let href = this.apiUrl;
		let options = {};
		let content = '';
		for (const val of inputs) {
			const input = val as HTMLInputElement;
			const key = input.getAttribute('name') || 'searchTag';
			if (input.value) this.filters[key] = JSON.parse(input.value);
			else delete this.filters[key];
		}
		let selectedFilters = '';
		for (const key in this.filters) {
			const filter = this.filters[key];
			if (key.toLowerCase().indexOf('date') >= 0) {
				const start = filter.filterDateRangeFrom.split('-')?.reverse().join('.');
				const end = filter.filterDateRangeTo.split('-')?.reverse().join('.');
				const label = `${start} - ${end}`;
				selectedFilters += this.filterRemover({ data: { label, id: key } });
			} else if (Array.isArray(filter)) {
				for (const id of filter) {
					const label = document.querySelector(`[type="checkbox"][data-id="${id}"]`)?.getAttribute('data-label') || id;
					selectedFilters += this.filterRemover({ data: { label, id } });
				}
			} else {
				const label = document.querySelector(`[type="checkbox"][data-id="${filter}"]`)?.getAttribute('data-label') || filter;
				selectedFilters += this.filterRemover({ data: { label, id: filter } });
			}
		}
		this.selectedFilters.innerHTML = selectedFilters;
		if (selectedFilters.length) {
			this.selectedFiltersContainer.classList.remove('d-none');
		} else {
			this.selectedFiltersContainer.classList.add('d-none');
		}
		if (this.apiUrl) {
			options = {
				headers: {
					"Content-Type": "application/json"
				},
				method: 'POST',
				body: JSON.stringify({
					"action": "search",
					"searchTerm": this.searchTerm,
					"filters": this.filters,
					"documentId": this.documentId,
					"pagination": {
						"totalResults": 0,
						"currentPage": this.currentPage,
						"perPage": this.perPage
					}
				})
			};
		} else {
			href = '/applyFilter.json';
		}
		await fetch(href, options)
			.then(response => response.json())
			.then((response) => {

				this.assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]");
				const noResult = `<div class="col-12 d-flex no-result">${this.noResultText}</div>`;
				const newCards: number[] = [];
				if (response.data?.pagination?.totalResults || response.data?.result?.length) {
					this.totalResults = response.data.pagination.totalResults;
					this.currentPage = response.data.pagination.currentPage;
					this.perPage = response.data.pagination.perPage;
					this.donwloadList = document.querySelector('.o-download-list .basket-row') as HTMLElement;
					for (const cardObject of response.data.result) {
						newCards.push(this.counter);
						content += `<div class="col-12 col-md-6 col-lg-4 px-0 d-flex-column px-md-0 px-lg-0 d-flex" data-counter="${this.counter++}">${this.card({ data: cardObject })}</div>`;
					}
					if (!content) content = noResult;
					if (loadMore) this.cardContainer.insertAdjacentHTML('beforeend', content);
					else this.cardContainer.innerHTML = content;
					if (this.donwloadList) {
						const hiddenButtons = this.$element.querySelectorAll('[data-download="add-to-donwloadlist"].d-none');
						hiddenButtons.forEach(btn => btn.classList.remove('d-none'));
					}
					this.loadMore?.classList.remove('loading-in-progress');
					if (this.perPage * this.currentPage >= this.totalResults) this.loadMore?.classList.add('d-none');
					else this.loadMore?.classList.remove('d-none');
					for(const nr of newCards){
						const buttonGroup = this.cardContainer.querySelector(`[data-counter="${nr}"] .m-button-group`) as HTMLElement;
						this.buttonGroupHandler(buttonGroup);
					}
					newCards.length = 0;
				} else {
					this.loadMore?.classList.add('d-none');
					this.cardContainer.innerHTML = noResult;
				}
				this.cardContainer.classList.remove('loading-in-progress');
			})
			.catch((err) => console.error(err));
	}

	private getPerPage() {
		const wv = window.innerWidth;
		if (wv > 1201) return this.perPageDesktop;
		else if (wv > 768 && wv <= 1200) return this.perPageTablet;
		else return this.perPageMobile;
	}

	private windowSizeHandler() {
		if (this.disablePerPageChecker) return;
		const perPage = this.getPerPage();
		if (this.perPage != perPage || !this.perPage) {
			this.perPage = perPage;
			const cardList = this.cardContainer.children;
			let counter = 0;
			for (const c of cardList) {
				const card = c as HTMLElement;
				if (card) {
					if (++counter <= this.perPage) card?.classList.remove('d-none');
					else card?.classList?.add('d-none');
				}
			}
		}
		this.perPage = perPage
		if (this.perPage * this.currentPage >= this.totalResults) {
			this.loadMore?.classList.add('d-none');
		} else {
			this.loadMore?.classList.remove('d-none');
		}

	}

	private init(elementName) {
		this.apiUrl = this.$element.getAttribute('data-api-url') || "";
		this.noResultText = this.$element.getAttribute('data-no-result-text') || "No results found";
		this.perPageDesktop = parseInt(this.$element.getAttribute('data-per-page-desktop') || "9");
		this.perPageTablet = parseInt(this.$element.getAttribute('data-per-page-tablet') || "8");
		this.perPageMobile = parseInt(this.$element.getAttribute('data-per-page-mobile') || "4");
		this.totalResults = parseInt(this.$element.getAttribute('data-total-results') || "5");
		this.currentPage = parseInt(this.$element.getAttribute('data-current-page') || "1");
		this.backDrop = this.$element.querySelector(`${elementName}-backdrop`) as HTMLElement;
		this.backDrop?.addEventListener('click', () => this.closeFilter());
		this.cardContainer = this.$element.querySelector(`${elementName}-search-list`) as HTMLElement;
		this.clearInput = this.$element.querySelector(`${elementName}-search-clear`) as HTMLButtonElement;
		this.clearInput?.addEventListener('click', () => {
			this.inputChecker('', elementName)
			this.applyFilter(1);
		});
		this.closeFilterButton = this.$element.querySelector(`${elementName}-close`) as HTMLButtonElement;
		this.closeFilterButton?.addEventListener('click', () => this.closeFilter());
		this.documentId = this.$element.getAttribute('data-document-id');
		this.filterApply = this.$element.querySelector(`${elementName}-buttons button`) as HTMLElement;
		this.filterApply?.addEventListener('click', () => this.applyFilter(1));
		this.filterDrawer = this.$element.querySelector(`${elementName}-container-wrapper`) as HTMLElement;
		this.loadMore = this.$element.querySelector(`${elementName}-pagination-wrapper .a-button`) as HTMLElement;
		this.selectedFiltersContainer = this.$element.querySelector(`${elementName}-filters-selected`) as HTMLElement;
		this.selectedFilters = this.selectedFiltersContainer?.querySelector('.js-selected-items') as HTMLElement;
		this.selectedFilters?.addEventListener('click', e => {
			const clicked = e.target as HTMLElement;
			if (clicked.classList.contains('js-remove-filter')) {
				const id = clicked.getAttribute('data-filter-id');
				if (id) {
					const check = document.querySelector(id === 'filterDateRange' ? '.js-range-checkbox' : `input[type="checkbox"][data-id="${id}"]`) as HTMLElement;
					check.click();
					this.applyFilter(1);
				}
			}
		});
		this.loadMore?.addEventListener('click', () => {
			this.loadMore.classList.add('loading-in-progress');
			this.applyFilter(this.currentPage + 1);
		});
		this.windowSizeHandler();
		window.addEventListener('resize', () => this.windowSizeHandler());
		this.toggleFilterButton = this.$element.querySelector(`${elementName}-filter-toggle`) as HTMLButtonElement;
		this.toggleFilterButton?.addEventListener('click', () => {
			this.filterDrawer.setAttribute('data-open', 'true');
			document.body?.classList.add('filters-opened');
		});
		this.searchInput = this.$element.querySelector(`${elementName}-search-input`) as HTMLInputElement;
		this.searchInput?.addEventListener('keyup', e => {
			this.inputChecker(e.target.value, elementName);
			if ((e.which == 13 || e.keyCode == 13) && e.target.value.length > 2) {
				this.applyFilter(1);
			}
		});
	}

	private inputChecker(e, elementName) {
		const val = e;
		const show = this.searchTerm ? true : false;
		this.searchActions = this.$element.querySelector(`${elementName}-search-buttons`) as HTMLElement;
		this.searchTerm = (val?.length > 2 || show) ? val : '';
		this.searchActions.setAttribute('data-show-buttons', (val?.length > 2 || show) ? 'true' : 'false');
		this.searchInput = this.$element.querySelector(`${elementName}-search-input`) as HTMLInputElement;
		this.searchInput.value = val;
		this.searchInput.setAttribute('data-value', val);
	}

	private submitSearh(elementName) {
		this.searchInput = this.$element.querySelector(`${elementName}-search-input`) as HTMLInputElement;
		this.submitSearch = this.$element.querySelector(`${elementName}-search-submit`) as HTMLButtonElement;
		this.submitSearch?.addEventListener('click', () => {
			this.inputChecker(this.searchInput?.value, elementName);
			this.applyFilter(1);
		});
	}
}

